import * as types from './rolesTypes';

const initialState = {
    rolesList: [],
    fetching: false,
    error: '',
};

const roles = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_ROLES:
            return {
                ...state,
                fetching: true,
            };
        case types.FETCH_ROLES_SUCCESS:
            return {
                ...state,
                fetching: false,
                rolesList: action.payload,
            };
        case types.FETCH_ROLES_FAILURE:
            return {
                ...state,
                fetching: false,
                error: action.error && action.error.data,
            };

        default:
            return state;
    }
};

export default roles;
